import { axiosInstance } from "@/lib/axios";
import { MODEL_PATH, type InteractionModel } from "@/features/interactions/models";

export type LikeableModel = InteractionModel;
export type LikeAction = "like" | "remove";

/**
 * `modelId` is a string as well as a number on purpose: the drops endpoints
 * never return a numeric `id` (a drop payload is keyed by `slug` only), and
 * the like route's own path parameter is documented as a string.
 *
 * The path segment comes from MODEL_PATH rather than from `modelType` directly
 * so the backend's identifier spelling lives in exactly one place — see
 * features/interactions/models.ts for the probe results behind each value.
 */
export async function toggleLike(
  modelType: LikeableModel,
  modelId: number | string,
  action: LikeAction
): Promise<any> {
  const { data } = await axiosInstance.post(
    `/like/${MODEL_PATH[modelType]}/${encodeURIComponent(String(modelId))}`,
    { action },
  );
  return data;
}
